import React from 'react'
import { View } from 'react-native'
import Typography from '@ui/typography'
import { useTranslation } from 'react-i18next'
import DetailBlock from '@ui/elements/Checklist/DetailBlock'

// TODO: replace with real data
const usePDMeasurement = () => {
  return {
    l: 32,
    r: 28,
  }
}

export default function MeasurementDetails() {
  const { t } = useTranslation(['checklist', 'ui'])
  const { l, r } = usePDMeasurement()

  return (
    <View className="gap-8">
      <View className="flex flex-row">
        <Typography variant="MD" className="color-light">
          {t('checklist:eyetest.pd.done')}
        </Typography>
      </View>
      <View className="flex-row gap-8">
        <DetailBlock value={r} label={t('common:right')} />
        <DetailBlock value={l} label={t('common:left')} />
      </View>
    </View>
  )
}
